import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "../styles/login.scss";
import i18n from "../i18n";
import { useTranslation } from "react-i18next";

const FirstLogin = () => {
  const url = process.env.REACT_APP_URL;
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    email: "",
    tempPassword: "",
    newPassword: "",
  });

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    try {
      const response = await axios.post(`${url}/audit/first-login`, {
        email: formData.email,
        tempPassword: formData.tempPassword,
        newPassword: formData.newPassword,
      });

      setSuccess("Password updated successfully. You can now log in.");
      setTimeout(() => {
        navigate("/login");
      }, 2000);
    } catch (err) {
      console.error(err);
      const msg =
        err.response?.data?.message || "An error occurred. Please try again.";
      setError(msg);
    }
  };

  return (
    <div className="login-container">
      <form className="form" onSubmit={handleSubmit}>
        <div className="language-switch">
          <button type="button" onClick={() => i18n.changeLanguage("en")}>
            🇬🇧
          </button>
          <button type="button" onClick={() => i18n.changeLanguage("es")}>
            🇪🇸
          </button>
        </div>

        <h2 className="title">{t("firstLogin") || "First Login"}</h2>

        <label className="label" htmlFor="email">
          {t("email") || "Email"}
          <input
            id="email"
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </label>

        <label className="label" htmlFor="tempPassword">
          {t("tempPassword") || "Temporary Password"}
          <input
            id="tempPassword"
            name="tempPassword"
            type="password"
            value={formData.tempPassword}
            onChange={handleChange}
            required
          />
        </label>

        <label className="label" htmlFor="newPassword">
          {t("newPassword") || "New Password"}
          <input
            id="newPassword"
            name="newPassword"
            type="password"
            value={formData.newPassword}
            onChange={handleChange}
            required
          />
        </label>
        {error && <div className="error">{error}</div>}
        {success && <div className="success">{success}</div>}

        <button className="button" type="submit">
          {t("signin") || "Sign In"}
        </button>
      </form>
    </div>
  );
};

export default FirstLogin;
